import { render, staticRenderFns } from "./AuthForm.vue?vue&type=template&id=6b65545a&scoped=true"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"
import style0 from "./AuthForm.vue?vue&type=style&index=0&id=6b65545a&prod&lang=scss"
import style1 from "./AuthForm.vue?vue&type=style&index=1&id=6b65545a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b65545a",
  null
  
)

export default component.exports